export var HARMONY_APP_ID = 2131;
export var HARMONY_APP_NAME = 'Harmony';
export var AI_HUB_APP_ID = 50339;
export var AI_HUB_APP_NAME = 'AIHub';
//# sourceMappingURL=constants.js.map